import React from "react";
import { useTranslation, Trans } from "react-i18next";

//scss
import "../scss/common.scss";
import "../scss/component.scss";

const SearchNotFound: React.FC = () => {
  const { t, i18n } = useTranslation();
  return (
    <>
      <section className="pt-40 pt-56-md">
        <div className="wrap-content-900">
          <div className="card sp-small">
            <p className="mb-10 ta-c">
              <img
                src={
                  require("../img/share/icon/icon_searchzero.svg")
                    .default
                }
                className="d-ib"
                />
            </p>
            <p className="fz-18 fw-b ta-c mb-16 c-dark_blue2">{t("ご希望の条件での検索結果は0件です")}</p>
            <p className="fz-16 ta-c-md c-blue_gray">
              <Trans i18nKey={"誠に申し訳ございませんが、指定した条件で見つかりませんでした。条件を変更して、再度検索を行っ誠に申し訳ございませんが、指定した条件で見つかりませんでしたてください。"} components={{br: <br />}} />
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default SearchNotFound;
